import React from "react";
import { useTranslation } from "react-i18next";
import s from "./modal.module.scss";

const Modal = ({
    children,
    open,
    onClose,
    title
}: {
    children: React.ReactNode;
    open: boolean;
    onClose: () => void;
    title: string;
}) => {
    const { t } = useTranslation();
    if (!open) return null

    return (
        <div className={s.modalContainer} onClick={onClose}>
            <div className={s.modal} onClick={(e) => e.stopPropagation()}>
                <div className={s.header}>
                    <p className={s.title}>{title}</p>
                </div>
                <div className={s.body}>
                    {children}
                </div>
                <div className={s.footer}>
                    <button onClick={onClose}>{t('modal.close')}</button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
